import React, { useState } from "react";

import axios from "axios";
import { config } from "../../config";

const apiUrl = config.apiUrl;

const CreateHero = ({onHeroCreated}) => {
  const [formData, setFormData] = useState({
    logo: null,
    headline: "",
    desc: "",
    image: null,
  });

  const [error, setError] = useState(null);


  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (files) {
      setFormData((prev) => ({ ...prev, [name]: files[0] }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = new FormData();
    data.append("logo", formData.logo);
    data.append("headline", formData.headline);
    data.append("desc", formData.desc);
    data.append("image", formData.image);

    try {
      await axios.post(`${apiUrl}/heroes`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      alert('Hero Section Created Successfully!');
      onHeroCreated();
    } catch (err) {
      setError("An error occurred while creating the hero.");
    }
  };

  return (
    <div className="p-6 max-w-lg mx-auto bg-white shadow rounded">
      <h2 className="text-2xl font-bold mb-4">Create Hero</h2>
      {error && <p className="text-red-500">{error}</p>}
      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label className="block text-gray-700">Logo</label>
          <input
            type="file"
            name="logo"
            onChange={handleChange}
            className="border w-full p-2"
            accept="image/*"
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700">Headline</label>
          <input
            type="text"
            name="headline"
            value={formData.headline}
            onChange={handleChange}
            className="border w-full p-2"
            required
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700">Description</label>
          <textarea
            name="desc"
            value={formData.desc}
            onChange={handleChange}
            className="border w-full p-2"
            required
          ></textarea>
        </div>
        <div className="mb-4">
          <label className="block text-gray-700">Image</label>
          <input
            type="file"
            name="image"
            onChange={handleChange}
            className="border w-full p-2"
            accept="image/*"
          />
        </div>
        <button
          type="submit"
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
        >
          Create Hero
        </button>
      </form>
    </div>
  );
};

export default CreateHero;
